<template>
  <div class="patient-form-wrapper">
    <div class="title">
      <div style="display: flex;align-items: center;">
        <i class="title-icon iconfont icon-huanzhexinxi"></i>
        <span class="title-label">患者信息</span>
      </div>
      <div style="display:flex;align-items:center;flex:1;">
        <button class="btn btn_newpatient" @click="refreshPage" style="margin-left:10px; margin-right:5px;width:120px;">新建</button>
        <i class="iconfont icon-zuidahua patient-max-btn" @click="showPatientFormMaxDialog = true" title="最大化" style="margin-left:auto;"></i>
      </div>
    </div>
    <div class="content">
      <div class="i-content">
        <el-form
          :model="form"
          ref="form"
          status-icon
          :rules="patientRules"
          size="mini"
          label-width="80px"
          label-position="left"
        >
          <el-form-item prop="id_in_hospital" ref="id_in_hospital_item">
            <span slot="label">ID<span style="color:red;">**</span></span>
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <el-autocomplete
                ref="idInput"
                v-model="form.id_in_hospital"
                :fetch-suggestions="querySearchId"
                :trigger-on-focus="false"
                :disabled="patient_id_disabled || readonly"
                placeholder="请输入ID"
                @select="handleSelectId"
                style="flex: 1;margin-right: 2%;"
                @blur="patientForm"
                @input="form.id_in_hospital = form.id_in_hospital.replace(/[\u4e00-\u9fa5]/g, '')"
              ></el-autocomplete>
              <div class="auto-create-btn" @click="getIdInHospital">
                自动生成</div>
            </div>
          </el-form-item>
          <el-form-item prop="name">
            <span slot="label">姓 名<span style="color:red;">**</span></span>
            <el-autocomplete
              :disabled="readonly"
              popper-class="my-autocomplete"
              v-model="form.name"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              placeholder="请输入姓名"
              @select="handleSelect"
              style="width:85%;"
              @blur="patientForm"
              ref="formName"
              @input="form.name = form.name.replace(/\d/g, '')"
            >
              <template slot-scope="{item}" style="width: 500px">
                <span class="name">{{item.name}}， ID: </span>
                <span class="phone">{{item.id_in_hospital}}</span>
                <!-- <div class="address">{{item.address}}</div> -->
              </template>
            </el-autocomplete>
          </el-form-item>
          <div class="patient-wrapper">
            <div class="sex-con">
              <div class="label" style="margin-right: 25%;">性别<span style="color:red;">**</span></div>
              <div>
                <el-radio-group
                  :disabled="readonly"
                  change="changeGender"
                  v-model="form.gender"
                  size="mini"
                  style="width:90px;margin-left:16%;height:30px;"
                  @change="patientForm"
                >
                  <el-radio-button label="男"></el-radio-button>
                  <el-radio-button label="女"></el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="race-con">
              <div class="label" style="margin-right: 10%;">年龄<span style="color:red;">*</span></div>
              <div id="input-box_1">
                <el-input
                  :disabled="readonly"
                  v-model="form.age"
                  placeholder=""
                  type
                  size="mini"
                  maxlength="3"
                  style="width:54%;"
                  @input="form.age = form.age.replace(/[^\d]/g, '')"
                  @blur="patientForm"
                ></el-input>
                <!--<div style="margin-left:6px;font-size: 14px;line-height: 28px;">岁</div>-->
              </div>
            </div>
          </div>
          <el-form-item prop="birthday" style="margin-top:10px;">
            <span slot="label">生日<span style="color:red;">*</span></span>
            <el-date-picker
              :disabled="readonly"
              v-model="form.birthday"
              align="right"
              type="date"
              :clearable="false"
              placeholder="年龄或生日选填一项"
              value-format="yyyy-MM-dd"
              default-value="1980-01-01"
              size="small"
              style="width:85%;"
              @blur="patientForm"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input
              :disabled="readonly"
              v-model="form.phone"
              placeholder="请输入手机号"
              type
              maxlength="11"
              style="width:85%;"
              @input="form.phone = form.phone.replace(/[^\d]/g, '')"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证">
            <el-input
              :disabled="readonly"
              v-model="form.idCardNumber"
              placeholder="请输入身份证号"
              type
              style="width:85%;"
              @blur="patientForm"
              maxlength="18"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="民族" prop="race">
            <el-select
              v-model="form.race"
              placeholder="请选择民族"
              size="mini"
              style="width:85%;"
              :disabled="readonly"
              @blur="patientForm"
            >
              <el-option
                v-for="item in races"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="皮肤类型"  prop="skin_type">
            <el-select
              v-model="form.skin_type"
              placeholder="请选择皮肤类型"
              size="small"
              style="width:85%;"
              :disabled="readonly"
              @blur="patientForm"
            >
              <el-option
                v-for="item in skinOpsType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="form.note"
              style="width: 100%;"
              placeholder="不得超过64个字"
              :disabled="readonly"
              type="textarea"
              @blur="patientForm"
              :maxlength="textAreaMaxLen"
            ></el-input>
          </el-form-item>
          <el-form-item label="肤色" v-if="!patientMore" prop="skin_color">
            <el-select
              v-model="form.skin_color"
              placeholder="请选择肤色"
              size="small"
              style="width:85%;"
              :disabled="readonly"
              @blur="patientForm"
            >
              <el-option
                v-for="item in skinOps"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地址" v-if="!patientMore">
            <el-input
              :disabled="readonly"
              v-model="form.address"
              placeholder="请输入地址"
              type
              style="width:85%;"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="籍贯" v-if="!patientMore">
            <el-input
              :disabled="readonly"
              v-model="form.nativePlace"
              placeholder="请输入籍贯"
              type
              style="width:85%;"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="国别" v-if="!patientMore">
            <el-input
              :disabled="readonly"
              v-model="form.country"
              placeholder="请输入国别"
              type
              style="width:85%;"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="职业" v-if="!patientMore">
            <el-select
              :disabled="readonly"
              v-model="form.profession"
              placeholder="请选择职业"
              size="mini"
              style="width:85%;"
              filterable
              allow-create
              default-first-option
              @blur="patientForm"
            >
              <el-option
                v-for="item in professionOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电子邮件" v-if="!patientMore" prop="email">
            <el-input
              :disabled="readonly"
              v-model="form.email"
              placeholder="请输入电子邮件"
              type
              style="width:85%;"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码2" v-if="!patientMore">
            <el-input
              :disabled="readonly"
              v-model="form.phone2"
              placeholder="请输入手机号码2"
              maxlength="11"
              style="width:85%;"
              @input="form.phone2 = form.phone2.replace(/[^\d]/g, '')"
              @blur="patientForm"
            ></el-input>
          </el-form-item>
          <el-form-item label="文化程度" v-if="!patientMore">
            <el-select
              :disabled="readonly"
              v-model="form.education"
              placeholder="请选择文化程度"
              size="mini"
              style="width:85%;"
              @blur="patientForm"
            >
              <el-option
                v-for="item in educationOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否吸烟" v-if="!patientMore">
            <el-select
              :disabled="readonly"
              v-model="form.smoking"
              placeholder="请选择"
              size="mini"
              style="width:85%;"
              @blur="patientForm"
            >
              <el-option
                v-for="item in smokingOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否饮酒" v-if="!patientMore">
            <el-select
              :disabled="readonly"
              v-model="form.drinking"
              placeholder="请选择"
              size="mini"
              style="width:85%;"
              @blur="patientForm"
            >
              <el-option
                v-for="item in drinkingOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="饮食习惯" v-if="!patientMore">
            <el-select
              :disabled="readonly"
              v-model="form.dietHabitArr"
              placeholder="请选择饮食习惯"
              size="mini"
              style="width:85%;"
              multiple
              @change="handleDietHabitChange"
              @blur="patientForm"
            >
              <el-option
                v-for="item in dietHabitOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="!patientMore" style="display:flex;margin-bottom:10px;">
            <el-form-item label="身高(cm)" style="flex:1;">
              <el-input
                :disabled="readonly"
                v-model="form.height"
                placeholder="身高"
                type="number"
                style="width:80%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="体重(kg)" style="flex:1;">
              <el-input
                :disabled="readonly"
                v-model="form.weight"
                placeholder="体重"
                type="number"
                style="width:80%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <!-- <div class="moreBtn" v-if="patientMore" style="width:88%;margin-bottom:5px;">
          <div class="show-more-text" @click="showPatientMore('show')">更多</div>
          <div class="iconfont show-more-btn" @click="showPatientMore('show')">&#xe7fe;</div>
        </div> -->
      </div>
    </div>
    <!-- 患者信息最大化对话框 -->
    <el-dialog
      title="患者信息"
      :visible.sync="showPatientFormMaxDialog"
      width="1050px"
      :close-on-click-modal="false"
      class="dialog patient-max-dialog"
      append-to-body
    >
      <div class="navBorder"></div>
      <el-form
        :model="form"
        status-icon
        :rules="patientRules"
        size="medium"
        label-width="100px"
        label-position="left"
        class="patient-max-form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="name" :class="{'field-filled': form.name}">
              <span slot="label">姓名<span style="color:red;">**</span></span>
              <el-autocomplete
                :disabled="readonly"
                popper-class="my-autocomplete"
                v-model="form.name"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                placeholder="请输入姓名"
                @select="handleSelect"
                style="width:100%;"
                @blur="patientForm"
                @input="form.name = form.name.replace(/\d/g, '')"
              >
                <template slot-scope="{item}">
                  <span class="name">{{item.name}}， ID: </span>
                  <span class="phone">{{item.id_in_hospital}}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="id_in_hospital" :class="{'field-filled': form.id_in_hospital}">
              <span slot="label">ID<span style="color:red;">**</span></span>
              <div style="display: flex;align-items: center;">
                <el-autocomplete
                  v-model="form.id_in_hospital"
                  :fetch-suggestions="querySearchId"
                  :trigger-on-focus="false"
                  :disabled="patient_id_disabled || readonly"
                  placeholder="请输入ID"
                  @select="handleSelectId"
                  style="flex: 1;"
                  @blur="patientForm"
                  @input="form.id_in_hospital = form.id_in_hospital.replace(/[\u4e00-\u9fa5]/g, '')"
                ></el-autocomplete>
                <div class="auto-create-btn" @click="getIdInHospital" style="margin-left:5px;">自动生成</div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <span slot="label">性别<span style="color:red;">**</span></span>
              <el-radio-group
                :disabled="readonly"
                v-model="form.gender"
                @change="patientForm"
              >
                <el-radio-button label="男"></el-radio-button>
                <el-radio-button label="女"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="birthday" :class="{'field-filled': form.birthday}">
              <span slot="label">出生日期<span style="color:red;">*</span></span>
              <el-date-picker
                :disabled="readonly"
                v-model="form.birthday"
                type="date"
                :clearable="false"
                placeholder="年龄或生日选填一项"
                value-format="yyyy-MM-dd"
                default-value="1980-01-01"
                style="width:100%;"
                @blur="patientForm"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :class="{'field-filled': form.age}">
              <span slot="label">年龄<span style="color:red;">*</span></span>
              <el-input
                :disabled="readonly"
                v-model="form.age"
                maxlength="3"
                style="width:100%;"
                @input="form.age = form.age.replace(/[^\d]/g, '')"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号码" prop="phone" :class="{'field-filled': form.phone}">
              <el-input
                :disabled="readonly"
                v-model="form.phone"
                placeholder="请输入手机号"
                maxlength="11"
                style="width:100%;"
                @input="form.phone = form.phone.replace(/[^\d]/g, '')"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="手机号码2" :class="{'field-filled': form.phone2}">
              <el-input
                :disabled="readonly"
                v-model="form.phone2"
                maxlength="11"
                style="width:100%;"
                @input="form.phone2 = form.phone2.replace(/[^\d]/g, '')"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身高(cm)" :class="{'field-filled': form.height}">
              <el-input
                :disabled="readonly"
                v-model="form.height"
                type="number"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="体重(kg)" :class="{'field-filled': form.weight}">
              <el-input
                :disabled="readonly"
                v-model="form.weight"
                type="number"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="皮肤类型" prop="skin_type" :class="{'field-filled': form.skin_type}">
              <el-select
                v-model="form.skin_type"
                placeholder="请选择皮肤类型"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in skinOpsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="肤色" prop="skin_color" :class="{'field-filled': form.skin_color}">
              <el-select
                v-model="form.skin_color"
                placeholder="请选择肤色"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in skinOps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证" :class="{'field-filled': form.idCardNumber}">
              <el-input
                :disabled="readonly"
                v-model="form.idCardNumber"
                placeholder="请输入身份证号"
                maxlength="18"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="地址" :class="{'field-filled': form.address}">
              <el-input
                :disabled="readonly"
                v-model="form.address"
                placeholder="请输入地址"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="职业" :class="{'field-filled': form.profession}">
              <el-select
                v-model="form.profession"
                placeholder="请选择职业"
                style="width:100%;"
                :disabled="readonly"
                filterable
                allow-create
                default-first-option
                @blur="patientForm"
              >
                <el-option
                  v-for="item in professionOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="文化程度" :class="{'field-filled': form.education}">
              <el-select
                v-model="form.education"
                placeholder="请选择文化程度"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in educationOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否吸烟" :class="{'field-filled': form.smoking}">
              <el-select
                v-model="form.smoking"
                placeholder="请选择"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in smokingOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="是否饮酒" :class="{'field-filled': form.drinking}">
              <el-select
                v-model="form.drinking"
                placeholder="请选择"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in drinkingOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="饮食习惯" :class="{'field-filled': form.dietHabitArr && form.dietHabitArr.length}">
              <el-select
                v-model="form.dietHabitArr"
                placeholder="请选择"
                style="width:100%;"
                :disabled="readonly"
                multiple
                @change="handleDietHabitChange"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in dietHabitOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="籍贯" :class="{'field-filled': form.nativePlace}">
              <el-input
                :disabled="readonly"
                v-model="form.nativePlace"
                placeholder="请输入籍贯"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="民族" prop="race" :class="{'field-filled': form.race}">
              <el-select
                v-model="form.race"
                placeholder="请选择民族"
                style="width:100%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in races"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮件" prop="email" :class="{'field-filled': form.email}">
              <el-input
                :disabled="readonly"
                v-model="form.email"
                placeholder="请输入电子邮件"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国别" :class="{'field-filled': form.country}">
              <el-input
                :disabled="readonly"
                v-model="form.country"
                placeholder="请输入国别"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注" :class="{'field-filled': form.note}">
              <el-input
                :disabled="readonly"
                v-model="form.note"
                type="textarea"
                :rows="2"
                style="width:100%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import moment from 'moment';
  // 民族json对象
  import raceJson from "../race.js";
  export default {
    
    inject: {
      commonData: ['commonData'],
      refreshPage: ['refreshPage'],
    },
    
    data() {
      const checkIdInHospital = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
          /*clearTimeout(this.timer);
          this.timer = setTimeout(async () => {
            if (this.useID) {
              callback();
            } else {
              if (!this.fromNewDiagnose) {
                if (!this.found) {
              
                  const obj = await this.patientIdRepeat(value);
                  // 如果找到患者就将患者信息填入
                  if (obj.id) {
                    callback('');
                    this.$message.error('ID已存在');
                    /!*this.useID = true;
                    this.isReset = true;
                    this.readonly = true;
                    this.fromNewDiagnose = true;
                    const birthday = moment(obj.birthday).format("YYYY-M-D");
                    this.form.id = obj.id;
                    this.form.id_in_hospital = obj.id_in_hospital;
                    this.form.name = obj.name;
                    this.form.birthday = birthday;
                    this.form.skin_color = obj.skin_color;
                    this.form.gender = obj.gender;
                    this.form.phone = obj.phone;
                    this.form.race = obj.race;
                    this.form.address = obj.address;
                    this.form.idCardNumber = obj.id_card_number;
                    this.form.nativePlace = obj.native_place;
                    this.form.country = obj.country;
                    this.form.profession = obj.profession;
                    this.form.email = obj.email;
                    this.patient_id = obj.id;
                    // 请求历史诊断列表
                    this.getHistoryCheckData();*!/
                  } else {
                    callback();
                  }
                  callback();
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }, 300);*/
        }
      };
      // 检查用户名
      const checkName = (rule, value, callback) => {
        if (value === "") {
          callback("");
        } else {
          callback();
        }
      };
      return {
        form: {
          id: "",
          // 患者id
          id_in_hospital: "",
          // 姓名
          name: "",
          birthday: "",
          age: '',
          skin_color: "",
          skin_type:"",
          gender: "男",
          phone: "",
          // 民族
          race: "",
          // 地址
          address: "",
          // 身份证号
          idCardNumber: "",
          // 籍贯
          nativePlace: "",
          country: "",
          // 职业
          profession: "",
          email: "",
          created_time: '',
          phone2: "",
          education: "",
          smoking: "",
          drinking: "",
          dietHabitArr: [],
          height: "",
          weight: "",
          note: "",
        },
        // 校验患者信息的规则
        patientRules: {
          id_in_hospital: {
            required: false,
            validator: checkIdInHospital,
            trigger: "blur"
          },
    
          name: {required: false, validator: checkName, trigger: "blur"},
        },
        races: raceJson.raceObj,
        skinOps: raceJson.skinOpn,
        skinOpsType:raceJson.skinOpnType,
        educationOpts: raceJson.educationOptions,
        professionOpts: raceJson.professionOptions,
        smokingOpts: raceJson.smokingOptions,
        drinkingOpts: raceJson.drinkingOptions,
        dietHabitOpts: raceJson.dietHabitOptions,
        timer: null,
        // 是否已选择id
        useID: false,
        fromNewDiagnose: false,
        // 新建患者成功后状态改变
        found: false,
        patient_id_disabled: false,
        readonly: false,
        isReset: false,
        patient_id: "",
        patientMore: true,
        showPatientFormMaxDialog: false,
        textAreaMaxLen: 512,
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
      };
    },
    
    methods: {
      // 验证id是否重复（新）
      async verifyIdRepeat() {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $id_in_hospital: String!
            ){
              getByIdInHospital(
                id_in_hospital: $id_in_hospital
              ){
                id
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              id_in_hospital: this.form.id_in_hospital,
            },
          });
          if (res.data.getByIdInHospital.length) {
            this.$message.error('患者ID被占用，请核实后重新填写相关信息');
          } else {
            return true;
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 根据id和姓名匹配用户
      async verificationPatient() {
        if (this.form.id_in_hospital && this.form.name) {
          try {
            const res = await this.$apollo.query({
              query: gql`query(
                $id_in_hospital: String!
                $patient_name: String!
              ){
                isAccessPatient(
                  id_in_hospital: $id_in_hospital
                  patient_name: $patient_name
                ){
                  id
                  id_in_hospital
                  name
                  birthday
                  age
                  skin_type
                  skin_color
                  gender
                  phone
                  race
                  address
                  id_card_number
                  native_place
                  country
                  profession
                  email
                  created_time
                  phone2
                  education
                  smoking
                  drinking
                  diet_habit
                  height
                  weight
                  note
                }
              }`,
              fetchPolicy: "no-cache",
              variables: {
                id_in_hospital: this.form.id_in_hospital,
                patient_name: this.form.name,
              },
            });
            if (res.data.isAccessPatient.length) {
              const data = res.data.isAccessPatient[0];
              const dataForm = {
                id: data.id,
                // 患者id
                id_in_hospital: data.id_in_hospital,
                // 姓名
                name: data.name,
                birthday: data.birthday === this.initialTime ? '' : moment(data.birthday).format('YYYY-MM-DD'),
                age: data.age > -1 ? (data.age + '') : '',
                skin_color: data.skin_color,
                skin_type:data.skin_type,
                gender: data.gender,
                phone: data.phone,
                // 民族
                race: data.race,
                // 地址
                address: data.address,
                // 身份证号
                idCardNumber: data.id_card_number,
                // 籍贯
                nativePlace: data.native_place,
                country: data.country,
                // 职业
                profession: data.profession,
                email: data.email,
                created_time: data.created_time,
                phone2: data.phone2 || '',
                education: data.education || '',
                smoking: data.smoking || '',
                drinking: data.drinking || '',
                dietHabitArr: this.dietHabitStringToArr(data.diet_habit),
                height: data.height || '',
                weight: data.weight || '',
                note: data.note || '',
              };
              this.useID = true;
              this.isReset = true;
              this.readonly = true;
              this.fromNewDiagnose = true;
              this.form = dataForm;
              this.patient_id = data.id;
              this.commonData.patientId = data.id;
              this.commonData.patientIdInHospital = data.id_in_hospital;
              this.commonData.balance = String(data.account_balance / 100);
              this.$refs.form.resetFields();
              this.$root.$emit('getHistoryList');
              // 自动生成治疗编号
              this.$root.$emit('automaticGetIdInHospital');
              this.$message({
                type: "success",
                message: "患者已登记，请继续填写病历信息",
              });
            } else {
              return await this.verifyIdRepeat();
            }
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
        }
      },
      patientForm() {
        setTimeout(async () => {
          const newval = this.form;
          if (!this.fromNewDiagnose) {
            if (this.patient_id !== "") {
              // 修改患者信息
              await this.modifySicker(newval);
            } else {
              // 进行匹配和查重
              const result = await this.verificationPatient();
              if (result) {
                if (
                  newval.id_in_hospital !== "" &&
                  newval.name !== "" &&
                  newval.gender !== "" &&
                  (newval.birthday || newval.age !== '')
                ) {
                  const obj = await this.patientIdRepeat(this.form.id_in_hospital);
                  if (!obj.id) {
                    let addRes = await this.addSicker(newval);
                    this.patient_id = addRes.data.addPatient.id;
                    this.commonData.patientId = addRes.data.addPatient.id;
                    this.commonData.patientIdInHospital = addRes.data.addPatient.id_in_hospital;
                    this.commonData.balance = String(addRes.data.addPatient.account_balance / 100);
                    this.form.id = addRes.data.addPatient.id;
                    this.getCreatedTime(addRes.data.addPatient.id);
                    this.$message({
                      type: "success",
                      message: "添加患者成功"
                    });
                    this.found = true;
                    this.patient_id_disabled = true;
                    // 自动生成治疗编号
                    this.$root.$emit('automaticGetIdInHospital');
                  }
                }
              }
            }
          }
          /*if (newval.gender === "女") {
            this.position = Object.keys(raceJson.position.woman);
            this.figureObj = raceJson.position.woman;
          } else {
            this.position = Object.keys(raceJson.position.man);
            this.figureObj = raceJson.position.man;
          }*/
        }, 300);
      },
      // 修改患者信息
      async modifySicker(formData) {
        if (
          formData.id_in_hospital !== "" &&
          formData.name !== "" &&
          formData.gender !== "" &&
          (formData.birthday || formData.age !== '')
        ) {
          let res;
          let pid = this.patient_id;
          res = await this.$apollo.mutate({
            mutation: gql`mutation (
              $id: Int!
              $id_in_hospital: String
              $name: String
              $gender: String
              $birthday: String
              $race: String
              $skin_color: String
              $skin_type: String
              $phone: String
              $address: String
              $id_card_number: String
              $native_place: String
              $country: String
              $profession: String
              $email: String
              $age: Int
              $phone2: String
              $education: String
              $smoking: String
              $drinking: String
              $diet_habit: String
              $height: Float
              $weight: Float
              $note: String
            ){
              modifyPatient(
                id: $id,
                age: $age,
                id_in_hospital: $id_in_hospital,
                name: $name,
                gender: $gender,
                birthday: $birthday,
                race: $race,
                skin_color: $skin_color,
                skin_type: $skin_type,
                phone: $phone,
                address: $address,
                id_card_number: $id_card_number,
                native_place: $native_place,
                country: $country,
                profession: $profession,
                email: $email,
                phone2: $phone2,
                education: $education,
                smoking: $smoking,
                drinking: $drinking,
                diet_habit: $diet_habit,
                height: $height,
                weight: $weight,
                note: $note
              )
            }`,
            variables: {
              id: pid,
              id_in_hospital: formData.id_in_hospital,
              name: formData.name,
              gender: formData.gender,
              birthday: formData.birthday ? formData.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
              race: formData.race,
              skin_color: formData.skin_color,
              skin_type:formData.skin_type,
              phone: formData.phone,
              address: formData.address,
              id_card_number: formData.idCardNumber,
              native_place: formData.nativePlace,
              country: formData.country,
              profession: formData.profession,
              email: formData.email,
              age: formData.age ? Number(formData.age) : -1,
              phone2: formData.phone2 || null,
              education: formData.education || null,
              smoking: formData.smoking || null,
              drinking: formData.drinking || null,
              diet_habit: this.dietHabitArrToString() || null,
              height: formData.height ? Number(formData.height) : null,
              weight: formData.weight ? Number(formData.weight) : null,
              note: formData.note || null,
            },
            fetchPolicy: "no-cache"
          });
        }
      },
      // 请求添加病人
      async addSicker(params) {
        let response = await this.$apollo.mutate({
          // Query
          mutation: gql`mutation(
            $id_in_hospital: String!
            $name: String!
            $gender: String!
            $birthday: String!
            $race: String!
            $skin_color: String!
            $skin_type: String!
            $phone: String!
            $address: String!
            $id_card_number: String!
            $native_place: String!
            $country: String!
            $profession: String!
            $email: String!
            $age: Int
            $phone2: String
            $education: String
            $smoking: String
            $drinking: String
            $diet_habit: String
            $height: Float
            $weight: Float
            $note: String
          ){
          addPatient(
             id_in_hospital: $id_in_hospital,
             name: $name,
             gender: $gender,
             birthday: $birthday,
             race: $race,
             skin_color: $skin_color,
             skin_type: $skin_type,
             phone: $phone,
             address: $address,
             id_card_number: $id_card_number,
             native_place: $native_place,
             country: $country,
             profession: $profession,
             email: $email,
             age: $age,
             phone2: $phone2,
             education: $education,
             smoking: $smoking,
             drinking: $drinking,
             diet_habit: $diet_habit,
             height: $height,
             weight: $weight,
             note: $note
             ){
               id
               id_in_hospital
               account_balance
             }
          }`,
          variables: {
            id_in_hospital: params.id_in_hospital,
            name: params.name,
            gender: params.gender,
            birthday: params.birthday ? params.birthday : moment(this.initialTime).format('YYYY-MM-DD'),
            race: params.race,
            skin_color: params.skin_color,
            skin_type: params.skin_type,
            phone: params.phone,
            address: params.address,
            id_card_number: params.idCardNumber,
            native_place: params.nativePlace,
            country: params.country,
            profession: params.profession,
            email: params.email,
            age: params.age ? Number(params.age) : -1,
            phone2: params.phone2 || null,
            education: params.education || null,
            smoking: params.smoking || null,
            drinking: params.drinking || null,
            diet_habit: this.dietHabitArrToString() || null,
            height: params.height ? Number(params.height) : null,
            weight: params.weight ? Number(params.weight) : null,
            note: params.note || null,
          },
        });
        return response;
      },
      async getCreatedTime(id) {
        const res = await this.$apollo.query({
          query: gql`query($id: Int!){
            patient(id: $id){
              id
              created_time
            }
          }`,
          fetchPolicy: "no-cache",
          variables: {
            id: id,
          },
        });
        this.form.created_time = moment(res.data.patient.created_time).format('YYYY-MM-DD');
      },
      // 检查患者id是否重复
      async patientIdRepeat(value) {
        const res = await this.$apollo.query({
          query: gql`query($keyword: String){
            patients(keyword: $keyword) {
              id
              name
              id_in_hospital
              gender
              birthday
              race
              skin_color
              skin_type
              address
              id_card_number
              native_place
              country
              profession
              email
              phone
              phone2
              education
              smoking
              drinking
              diet_habit
              height
              weight
              note
            }
          }`,
          variables: {
            keyword: value,
          },
          fetchPolicy: "no-cache"
        });
        const arr = res.data.patients;
        const filterArr = arr.filter(item => {
          return item.id_in_hospital === value;
        });
        let obj = {};
        if (filterArr.length >= 1) {
          obj = filterArr[0];
        }
        return obj;
      },
      // id可选项
      async querySearchId(queryString, callback) {
        if (queryString !== "") {
          const res = await this.$apollo.query({
            query: gql`query($keyword: String){
                      patients(keyword: $keyword) {
                        id
                        name
                        id_in_hospital
                        gender
                        birthday
                        race
                        skin_color
                        skin_type
                        address
                        id_card_number
                        native_place
                        country
                        profession
                        email
                        phone
                        age
                        created_time
                        account_balance
                        phone2
                        education
                        smoking
                        drinking
                        diet_habit
                        height
                        weight
                        note
                      }
                  }`,
            fetchPolicy: "no-cache",
            variables: {
              keyword: queryString,
            },
          });
          const arr = res.data.patients;
          const newArr = [];
          for (let i of arr) {
            newArr.push({
              value: `${i.id_in_hospital}`,
              form: {
                id: i.id,
                // 患者id
                id_in_hospital: i.id_in_hospital,
                // 姓名
                name: i.name,
                birthday: i.birthday === this.initialTime ? '' : moment(i.birthday).format('YYYY-MM-DD'),
                age: i.age > -1 ? (i.age + '') : '',
                skin_color: i.skin_color,
                skin_type:i.skin_type,
                gender: i.gender,
                phone: i.phone,
                // 民族
                race: i.race,
                // 地址
                address: i.address,
                // 身份证号
                idCardNumber: i.id_card_number,
                // 籍贯
                nativePlace: i.native_place,
                country: i.country,
                // 职业
                profession: i.profession,
                email: i.email,
                created_time: i.created_time,
                account_balance: i.account_balance,
                phone2: i.phone2 || '',
                education: i.education || '',
                smoking: i.smoking || '',
                drinking: i.drinking || '',
                dietHabitArr: this.dietHabitStringToArr(i.diet_habit),
                height: i.height || '',
                weight: i.weight || '',
                note: i.note || '',
              },
              id: i.id
            });
          }
          callback(newArr);
        }
      },
      // 选择了id
      handleSelectId(item) {
        this.useID = true;
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form = item.form;
        this.patient_id = item.id;
        this.commonData.patientId = item.id;
        this.commonData.patientIdInHospital = item.form.id_in_hospital;
        this.commonData.balance = String(item.form.account_balance / 100);
        this.$refs.form.resetFields();
        this.$root.$emit('getHistoryList');
        // 自动生成治疗编号
        this.$root.$emit('automaticGetIdInHospital');
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      // 远程搜索
      async querySearch(queryString, cb) {
        let apolloRes = await this.$apollo.query({
          query: gql`
          query($keyword: String!) {
            patients(keyword: $keyword) {
              id
              name
              gender
              phone
              address
              country
              id_card_number
              native_place
              profession
              email
              birthday
              id_in_hospital
              race
              skin_color
              skin_type
              age
              created_time
              account_balance
              phone2
              education
              smoking
              drinking
              diet_habit
              height
              weight
              note
            }
          }
        `,
          variables: {
            keyword: queryString
          },
          fetchPolicy: "no-cache"
        });
        const restaurants = apolloRes.data.patients;
        const results = queryString
          ? restaurants.filter(this.filterName(queryString))
          : restaurants;
        cb(results);
      },
      filterName(queryString) {
        return restaurant => {
          return (
            restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
          );
        };
      },// 处理选中状态选中之后的item统一在这里进行复制 queryString 远程查询结果在这里重新复制item form
      handleSelect(item) {
        // 重置form表单验证状态
        this.$refs.form.resetFields();
    
        this.isReset = true;
        this.readonly = true;
        this.fromNewDiagnose = true;
        this.form.name = item.name;
        this.form.created_time = item.created_time;
        this.form.age = item.age > -1 ? (item.age + '') : '';
        this.form.birthday = item.birthday === this.initialTime ? '' : moment(item.birthday).format('YYYY-MM-DD');
        this.form.id = item.id;
        this.form.id_in_hospital = item.id_in_hospital;
        this.form.gender = item.gender;
        this.form.skin_color = item.skin_color;
        this.form.skin_type = item.skin_type;
        this.form.race = item.race;
        this.form.phone = item.phone;
        this.patient_id = item.id;
        this.form.address = item.address;
        this.form.idCardNumber = item.id_card_number;
        this.form.nativePlace = item.native_place;
        this.form.country = item.country;
        this.form.profession = item.profession;
        this.form.email = item.email;
        this.form.phone2 = item.phone2 || '';
        this.form.education = item.education || '';
        this.form.smoking = item.smoking || '';
        this.form.drinking = item.drinking || '';
        this.form.dietHabitArr = this.dietHabitStringToArr(item.diet_habit);
        this.form.height = item.height || '';
        this.form.weight = item.weight || '';
        this.form.note = item.note || '';
        this.commonData.patientId = item.id;
        this.commonData.patientIdInHospital = item.id_in_hospital;
        this.commonData.balance = String(item.account_balance / 100);
        this.$root.$emit('getHistoryList');
        // 自动生成治疗编号
        this.$root.$emit('automaticGetIdInHospital');
        this.$message({
          type: "success",
          message: "患者已登记，请继续填写病历信息",
        });
      },
      // 将最新一次填写的检查信息填上
      handleExamineInfo() {
        if (this.applyDoctors.length > 0) {
          this.$set(this.form2, 'applicant', this.applyDoctors[this.applyDoctors.length - 1].value);
        }
        if (this.applyUnit.length > 0) {
          this.$set(this.form2, 'applicant_unit', this.applyUnit[this.applyUnit.length - 1].value);
        }
        if (this.review_doctor_cache.length > 0) {
          this.$set(this.form2, 'review_doctor', this.review_doctor_cache[this.review_doctor_cache.length - 1].value)
        }
        if (this.check_unit.length > 0) {
          this.$set(this.form2, 'unit', this.check_unit[this.check_unit.length - 1].value)
        }
        if (this.feeList.length > 0) {
          this.$set(this.form2, 'fee', this.feeList[this.feeList.length - 1].value)
        }
      },
      
      showPatientMore(params) {
        if (params === "show") {
          this.patientMore = false;
        } else {
          this.patientMore = true;
        }
      },
      // 饮食习惯互斥处理：正常与其他选项互斥
      handleDietHabitChange(val) {
        if (val.includes('正常') && val.length > 1) {
          // 如果选了"正常"且还有其他选项，根据最后选择决定
          const lastItem = val[val.length - 1];
          if (lastItem === '正常') {
            this.form.dietHabitArr = ['正常'];
          } else {
            this.form.dietHabitArr = val.filter(v => v !== '正常');
          }
        }
      },
      // 将数组转为逗号分隔字符串
      dietHabitArrToString() {
        return this.form.dietHabitArr.join(',');
      },
      // 将逗号分隔字符串转为数组
      dietHabitStringToArr(str) {
        if (!str) return [];
        return str.split(',').filter(s => s);
      },
      // 自动生成id
      async getIdInHospital() {
        this.$refs.id_in_hospital_item.resetField();
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation{
              gentPatientIDInHospital
            }`
          });
          this.form.id_in_hospital = res.data.gentPatientIDInHospital;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 获取患者的信息
      async getPatientInfo(id) {
        try {
          const res = await this.$apollo.query({
            query: gql`query($id: Int!){
              patient(id: $id){
                id
                id_in_hospital
                name
                gender
                age
                birthday
                phone
                id_card_number
                race
                skin_color
                skin_type
                address
                native_place
                country
                profession
                email
                created_time
                account_balance
                phone2
                education
                smoking
                drinking
                diet_habit
                height
                weight
                note
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              id: id,
            },
          });
          const patientinfo = res.data.patient;
          this.form.id = patientinfo.id;
          this.form.created_time = moment(patientinfo.created_time).format('YYYY-MM-DD');
          this.form.id_in_hospital = patientinfo.id_in_hospital;
          this.form.birthday = patientinfo.birthday === this.initialTime ? '' : moment(patientinfo.birthday).format('YYYY-MM-DD');
          this.form.age = patientinfo.age > -1 ? (patientinfo.age + '') : '';
          this.form.phone = patientinfo.phone;
          this.form.profession = patientinfo.profession;
          this.form.gender = patientinfo.gender;
          this.form.name = patientinfo.name;
          this.form.race = patientinfo.race;
          this.form.skin_color = patientinfo.skin_color;
          this.form.skin_type = patientinfo.skin_type;
          this.form.address = patientinfo.address;
          this.form.idCardNumber = patientinfo.id_card_number;
          this.form.nativePlace = patientinfo.native_place;
          this.form.country = patientinfo.country;
          this.form.email = patientinfo.email;
          this.form.phone2 = patientinfo.phone2 || '';
          this.form.education = patientinfo.education || '';
          this.form.smoking = patientinfo.smoking || '';
          this.form.drinking = patientinfo.drinking || '';
          this.form.dietHabitArr = this.dietHabitStringToArr(patientinfo.diet_habit);
          this.form.height = patientinfo.height || '';
          this.form.weight = patientinfo.weight || '';
          this.form.note = patientinfo.note || '';
          this.patient_id = patientinfo.id;
          this.commonData.patientId = patientinfo.id;
          this.commonData.patientIdInHospital = patientinfo.id_in_hospital;
          this.commonData.balance = String(patientinfo.account_balance / 100);
          this.readonly = true;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
    },
    
    async created() {
      // console.log("In CommonPatientForm,created..");
      // console.log("this.$route.query:",this.$route.query);
      // console.log("this.$store.state.cosmetologyData.status:",this.$store.state.cosmetologyData.status);
      // 2024-12-09 modified by Steven. 解决新建tab页面打开美容主页，参数传递问题. 将 this.$store.commit("addCosmetology"）从PatientList.vue移动到这里；
      // 只需要在本组件执行 this.$store.commit("addCosmetology"），即可将参数传递至 HairdressingManager 中的其他兄弟组件；
      if(this.$route.query){
        if(this.$route.query.from){
          if (this.$route.query.from=="newCosmetology"){        
            const patient_id = this.$route.query.patient_id;
            this.$store.commit("addCosmetology", {
              patient_id:patient_id
            }); 
            this.$route.query.from = "";   
          }   
          if (this.$route.query.from=="modifyCosmetology"){   
            this.$store.commit('addModifyCosmetology', {
              patient_id: this.$route.query.patient_id,
              treat_no: this.$route.query.treat_no,
              current_times: this.$route.query.current_times,
              total_times: this.$route.query.total_times,
              parent_id: this.$route.query.parent_id ? this.$route.query.parent_id : this.$route.query.treat_no,
            });
            this.$route.query.from = "";   
          }      
        }
      }
      // console.log("this.$store.state.cosmetologyData.status:",this.$store.state.cosmetologyData.status);
      // console.log("this.$store.state.modifyCosmetologyData.status:",this.$store.state.modifyCosmetologyData.status);

    },

    async mounted() {
      // console.log("In CommonPatientForm,mounted,this.$route.query:",this.$route.query);
      // 如果是继续治疗就填上患者信息
      if (this.$store.state.continueTreatData.status) {
        this.$store.commit('addContinueTreatStatusCount');
        await this.getPatientInfo(this.$store.state.continueTreatData.patient_id);
      }
      // 如果是点击编辑跳转过来
      if (this.$store.state.modifyCosmetologyData.status) {
        this.$store.commit('addModifyCosmetologyStatusCount');
        await this.getPatientInfo(this.$store.state.modifyCosmetologyData.patient_id);
      }
      // 如果是点击历史列表跳转过来
      if (this.$store.state.cosmetologyData.status) {
        this.$store.commit('addCosmetologyStatusCount');
        await this.getPatientInfo(this.$store.state.cosmetologyData.patient_id);
      }
      // console.log("In CommonPatientForm");
      // console.log("this.$store.state.continueTreatData.statusCount:",this.$store.state.continueTreatData.statusCount);
      // console.log("this.$store.state.modifyCosmetologyData.statusCount:",this.$store.state.modifyCosmetologyData.statusCount);
      // console.log("this.$store.state.cosmetologyData.statusCount:",this.$store.state.cosmetologyData.statusCount);
    },
  
  }
</script>

<style lang="less" scoped>
  .el-form-item {
    margin-bottom: 10px;
  }
  .patient-wrapper,
  .sex-con,
  .race-con{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }
  .sex-con {
    display: flex;
    align-items: center;
    margin-right: 3%;
  }
  .label {
    font-size: 14px;
    color: #606266;
    margin-right: 6%;
    white-space: nowrap;
  }
  .race-con {
    margin-left: 19%;
    #input-box_1{
      display: flex;
    }
  }
  .moreBtn {
    position: relative;
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  
    .moreButton {
      width: 20%;
      height: 20px;
      background: #61a2bf;
      color: #fff;
      cursor: pointer;
      padding: 5px 30px;
      line-height: 20px;
      border-radius: 5px;
      font-size: 15px;
      text-align: center;
    }
  }
  .auto-create-btn{
    width: 66px;
    height:28px;
    color: #fff;
    box-sizing: border-box;
    background-color: rgb(77,162,190);
    margin-right: 15%;
    font-size: 14px;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid rgb(220,223,230);
    user-select: none;
    cursor: pointer;
    text-align: center;
  }
  
  .patient-form-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .title {
      display: flex;
      justify-content: space-between;
      width: calc(100% - 40px);
      color: #48a3c2;
      font-size: 16px;
      border-bottom: 2px solid #48a3c2;
      padding: 5px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      height: 25px;
      text-align: left;
      align-items: center;
      .title-icon{
        font-size:24px;
        margin-right:10px;
      }
      .title-label{
        white-space: nowrap;
        font-size: 18px;
      }
    }
    .content{
      flex: 1;
      overflow-y: auto;
    }
  }

  .show-more-text{
    color: rgb(97,162,191);
    font-size: 17px;
    font-weight: bold;
    cursor: pointer
  }
  .show-more-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(97,162,191);
    font-size: 19px;
    cursor: pointer;
  }

  .patient-max-btn {
    cursor: pointer;
    font-size: 18px;
    color: #4da2be;
    margin-left: 5px;
    vertical-align: middle;
  }
  .patient-max-btn:hover {
    color: #66b1ff;
  }

  .patient-max-dialog {
    .el-dialog__body {
      padding: 10px 20px 20px;
      max-height: 80vh;
      overflow-y: auto;
    }
  }
  .patient-max-form {
    /deep/ .el-form-item__label {
      font-size: 17px;
    }
    /deep/ .el-input__inner {
      font-size: 17px;
    }
    /deep/ .el-radio-button__inner {
      font-size: 17px;
    }
    /deep/ .el-textarea__inner {
      font-size: 17px;
    }
    .field-filled {
      /deep/ .el-input, /deep/ .el-textarea {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 4px;
          right: 4px;
          width: 8px;
          height: 8px;
          background: #4da2be;
          border-radius: 50%;
          z-index: 1;
          pointer-events: none;
        }
      }
    }
  }
  .dialog{
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
      margin-top: -16px;
      margin-bottom: 16px;
    }
  }
</style>
